/**
  Danh sách chức năng các màn hình
 */
enum ScreenNameType {
  // Common Screen
  LIST_UTILITIES = "ListUtilities",
  PASSWORD_LOGIN = "PasswordLogin",
  ChangePassword = "ChangePassword",
  MAIN = "Main",
  HOME = "Home",
  NOT_FOUND = "NotFound",
  // Transfer
  LIST_TRANSFER = "ListTransferScreen",
  /**@description Chuyển tiền nội bộ*/
  TRANS_LOCAL = "TransferLocal",
  TRANS_LOCAL_CONFIRM = "TransferLocalConfirm",
  TRANS_LOCAL_AUTH = "TransferLocalAuth",
  TRANS_LOCAL_SUCCESS = "TransferLocalSuccess",

  /**@description Chuyển tiền liên ngân hàng*/
  TRANS_FOREIGN = "TransferForeign",
  TRANS_FOREIGN_CONFIRM = "TransForeignConfirm",
  TRANS_FOREIGN_AUTH = "TransForeignAuth",
  TRANS_FOREIGN_SUCCESS = "TransForeignSuccess",

  /**@description Chuyển tiền napas 247*/
  TRANS_247 = "Transfer247",
  TRANS_247_CONFIRM = "Transfer247Confirm",
  TRANS_247_AUTH = "Transfer247Auth",
  TRANS_247_SUCCESS = "Transfer247Success",

  /**@description Chuyển tiền chứng khoán*/
  TRANS_STOCK = "TransferStock",
  TRANS_STOCK_CONFIRM = "TransferStockConfirm",
  TRANS_STOCK_AUTH = "TransferStockAuth",
  TRANS_STOCK_SUCCESS = "TransferStockSuccess",

  /**@description Chuyển tiền từ thiện*/
  TRANS_CHARITY = "TransferCharity",
  TRANS_CHARITY_CONFIRM = "TransferCharityConfirm",
  TRANS_CHARITY_AUTH = "TransferCharityAuth",
  TRANS_CHARITY_SUCCESS = "TransferCharitySuccess",

  // TopUp - Billing
  LIST_PAYMENTS = "ListPayments",

  /**@description Nạp tiền điện tử*/
  TOP_UP_CREATE = "TopUpCreate",
  TOP_UP_CONFIRM = "TopUpConfirm",
  TOP_UP_AUTH = "TopUpAuth",
  TOP_UP_SUCCESS = "TopUpSuccess",

  /**@description Thanh toán hoá đơn*/
  BILLINGS_CREATE = "BillingsCreate",
  BILLINGS_CONFIRM = "BillingsConfirm",
  BILLINGS_AUTH = "BillingsAuth",
  BILLINGS_SUCCESS = "BillingsSuccess",

  /**@description Nạp tiền điện tử tự động*/
  AUTO_TOP_UP_LIST = "AutoToUpRoll",
  AUTO_TOP_UP_CREATE = "AutoTopUpCreate",
  AUTO_TOP_UP_CONFIRM = "AutoTopUpConfirm",
  AUTO_TOP_UP_AUTH = "AutoTopUpAuth",
  AUTO_TOP_UP_SUCCESS = "AutoTopUpSuccess",
  AUTO_TOP_UP_HISTORY = "AutoTopUpHistory",

  /**@description Thanh toán hoá đơn tự động*/
  AUTO_BILLINGS_LIST = "AutoBillingRoll",
  AUTO_BILLINGS_CREATE = "AutoBillingsCreate",
  AUTO_BILLINGS_CONFIRM = "AutoBillingsConfirm",
  AUTO_BILLINGS_AUTH = "AutoBillingsAuth",
  AUTO_BILLINGS_SUCCESS = "AutoBillingsSuccess",
  AUTO_BILLINGS_HISTORY = "AutoBillingsHistory",

  /**@description Thanh toán thẻ tín dụng*/
  PAYMENT_CARD_CREATE = "PaymentCard",
  PAYMENT_CARD_CONFIRM = "PaymentCardConfirm",
  PAYMENT_CARD_AUTH = "PaymentCardAuth",
  PAYMENT_CARD_SUCCESS = "PaymentCardSuccess",

  // Cài đặt chung
  SETTINGS = "Settings",

  // Quản lý tài khoản
  LIST_ACCOUNT_MANAGEMENT = "ListAccountManagement",
  INFORMATION_ACCOUNT = "InformationAccount",
  ACCOUNT_ROLL = "AccountRoll",
  DETAIL_ACCOUNT_ROLL = "DetailAccountRoll",
  /**@description Sao kê */
  LIST_STATEMENT = "ListStatement",
  /**@description Lịch sử giao dịch */
  LIST_TRANSACTION_HISTORY = "ListTransactionHistory",

  // Tiết kiệm
  LIST_FUNCTION_TERM_DEPOSIT = "ListFunctionTermDeposit",
  /**@description Danh sách sổ TK */
  LIST_TERM_DEPOSIT = "ListTermDeposit",

  /**@description Mở sổ*/
  TERM_DEPOSIT_OPEN_CREATE = "TermDepositOpen",
  TERM_DEPOSIT_OPEN_CONFIRM = "TermDepositOpenConfirm",
  TERM_DEPOSIT_OPEN_AUTH = "TermDepositOpenAuth",
  TERM_DEPOSIT_OPEN_SUCCESS = "TermDepositOpenSuccess",

  /**@description Tất toán */
  TERM_DEPOSIT_STATEMENT_CREATE = "TermDepositStatement",
  TERM_DEPOSIT_STATEMENT_CONFIRM = "TermDepositStatementConfirm",
  TERM_DEPOSIT_STATEMENT_AUTH = "TermDepositStatementAuth",
  TERM_DEPOSIT_STATEMENT_SUCCESS = "TermDepositStatementSuccess",

  /**@description Nạp thêm */
  TERM_DEPOSIT_TOP_UP_CREATE = "TermDepositTopUp",
  TERM_DEPOSIT_TOP_UP_CONFIRM = "TermDepositTopUpConfirm",
  TERM_DEPOSIT_TOP_UP_AUTH = "TermDepositTopUpAuth",
  TERM_DEPOSIT_TOP_UP_SUCCESS = "TermDepositTopUpSuccess",

  /**@description Dịch vụ thẻ */
  LIST_CARDS = "ListCards",
  CARD_AUTH = "CardAuth",
  CARD_STATEMENT = "CardStatement",
  CARD_HISTORY = "CardHistory",
  CARD_PHYSICAL_HISTORY = "CardPhysicalRegister",

  /**@description Giới thiệu Pvcombank */
  LIST_ABOUT_US = "ListAboutUs",
  ANSWER_QUESTIONS = "AnswerQuestions",
  USER_GUIDE = "UserGuide",

  /**@description Thư viện QR */
  QR_LIBRARY = "QRLibrary",

  NOTIFICATIONS = "Notifications",

  /**@description Đổi quà PVOne loyalty */
  PV_ONE = "PVOne",
}

export default ScreenNameType;
